export const AUTH_CONFIG = {
  domain: "login.appinchina.co",
  clientId: "BvlHI2XtFzOQ2rxO2Q9ruB68TziX4G2j",
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL
};
